export interface UserLockStatus {
    isLockedOut: boolean;
    userId: number;
}

export class UserAccount {
    userId: number;

    constructor(private User){}

    getUserId(): number {
        return this.userId;
    }

    setUserId(userId: number){
        this.userId = userId;
    }

    locked(){
        if(!this.userId){
            return;
        }

        return this.User
            .locked({ userId: this.userId });
    }

    unlock() {
        if(!this.userId){
            return;
        }
        
        return this.User
            .unlock({ userId: this.userId });
    }
}

class UserAccountProvider implements ng.IServiceProvider {
    $get = ['User', (User) => new UserAccount(User)];
}

angular
    .module('app')
    .provider('UserAccount', UserAccountProvider);